import { create } from "zustand";
import axios from "axios";
import Cookies from "js-cookie";

const orderStore = create((set) => ({
  orderDetails: null,
  isLoading: true,
  isOrderSuccessfully: false,

  setIsOrderSuccessfully: ({ value }) => {
    set({ isOrderSuccessfully: value });
  },

  setOrderDetailsNull: () => {
    set({ orderDetails: null });
  },

  createOrder: async ({
    productID,
    selectedSize,
    selectedColor,
    quantity,
    purchasePrice,
    paymentID,
    orderDeliveryStatusTimeID,
  }) => {
    const res = await axios.post(
      "/site/create-order",
      {
        productID,
        selectedSize,
        selectedColor,
        quantity,
        purchasePrice,
        paymentID,
        orderDeliveryStatusTimeID,
      }
    );

    const { orderDetails } = orderStore.getState();
    const data = orderDetails ? orderDetails : [];
    data.push(res.data.orderDetail);
    set({ orderDetails: data });
  },

  fetchAllUserOrders: async () => {
    try {
      const res = await axios.get("/site/fetch-all-user-order");
      if (res.data.orderDetail.length) {
        set({ orderDetails: res.data.orderDetail });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },

  updateOrderStatusForReturn: async ({ paymentID }) => {
    try {
      set({ isLoading: true });
      const res = await axios.put(
        `/site/return-order-product/${paymentID}`,
        {
          order_delivery_status: "Return",
        }
      );

      set({ orderDetails: res.data.orderDetail });
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },
}));

export default orderStore;
